/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Alexander Golshtein
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.1.0
 */
import { IPageBillsTranslation } from '../../types';

const initTranslationPageBills: IPageBillsTranslation = {
    table: {
        accountNumber: {
            header: '',
        },
        amount: {
            header: '',
        },
        billDate: {
            header: '',
        },
        billDebt: {
            header: '',
        },
        billId: {
            header: '',
        },
        billNumber: {
            header: '',
        },
        billPaid: {
            header: '',
        },
        billPeriod: {
            header: '',
        },
        checked: {
            header: '',
        },
        clientId: {
            header: '',
        },
        clientName: {
            header: '',
        },
        contract: {
            header: '',
        },
        customer: {
            header: '',
        },
        disableCheckedAllMessage: '',
        fucturies: {
            header: '',
        },
        isPaid: {
            header: '',
        },
        paidAmount: {
            header: '',
        },
        paymentDate: {
            header: '',
        },
        payStatus: {
            header: '',
        },
        unpaidAmount: {
            header: '',
        },
    },
    tableFooter: {
        basketTitle: '',
    },
    title: {
        disableExport: '',
        dropFilters: '',
        exportBtn: '',
        header: '',
        helperText: '',
        subTitles: {
            bills: '',
            billsAccount: '',
            billsUnpaid: '',
            billsUnpaidAccount: '',
            wizardFastBillsDocSubtitle: '',
            wizardFastReportDocSubstitle: '',
        },
        tableSetting: {
            applyBtn: '',
            closeBtn: '',
            footnote: '',
            subTitle: '',
            title: '',
            titleBtn: '',
        },
    },
};

export default initTranslationPageBills;
